// Maps every icon export name to a lazy module loader so icons can be loaded dynamically,
// without bundling all icons into the importing bundle.
// Add an entry here when you add a new icon that will be loaded dynamically with
// `loadIconComponent(iconName)`

export type IconLoadersKeys = keyof typeof IconLoaders

export const IconLoaders = {
  ActivitiesSessionIcon: () => import('./ActivitiesSessionIcon'),
  AudioPauseIcon: () => import('./AudioPauseIcon'),
  AudioPlayIcon: () => import('./AudioPlayIcon'),
  ActivityIcon: () => import('./ActivityIcon'),
  ActivityStarSquareIcon: () => import('./ActivityStarSquareIcon'),
  AddIcon: () => import('./AddIcon'),
  AddToCalendarIcon: () => import('./AddToCalendarIcon'),
  AlarmIcon: () => import('./AlarmIcon'),
  AlcoholUseDisorderTherapyIcon: () => import('./AlcoholUseDisorderTherapyIcon'),
  AlertIcon: () => import('./AlertIcon'),
  AlertIconStroke: () => import('./AlertIconStroke'),
  AlertLoudIcon: () => import('./AlertLoudIcon'),
  AlertQuietIcon: () => import('./AlertQuietIcon'),
  AlignLeftIcon: () => import('./AlignLeftIcon'),
  ArrowIcon: () => import('./ArrowIcon'),
  ArticleLayerIcon: () => import('./ArticleLayerIcon'),
  AssessmentIcon: () => import('./AssessmentIcon'),
  AttentionIcon: () => import('./AttentionIcon'),
  AuroraAICoachAvatarIcon: () => import('./AuroraAICoachAvatarIcon'),
  AuroraCheckMarkIcon: () => import('./AuroraCheckMarkIcon'),
  Avatar: () => import('./Avatar'),
  AvatarIcon: () => import('./AvatarIcon'),
  BackpackIcon: () => import('./BackpackIcon'),
  BlendedCareMedicineIcon: () => import('./BlendedCareMedicineIcon'),
  BlendedCareTherapyIcon: () => import('./BlendedCareTherapyIcon'),
  BoltIcon: () => import('./BoltIcon'),
  BrainIcon: () => import('./BrainIcon'),
  BookSessionsIcon: () => import('./BookSessionsIcon'),
  BulletIcon: () => import('./BulletIcon'),
  CalendarBookingIcon: () => import('./CalendarBookingIcon'),
  CalendarEmptyIcon: () => import('./CalendarEmptyIcon'),
  CalendarIcon: () => import('./CalendarIcon'),
  CaregiverSessionIcon: () => import('./CaregiverSessionIcon'),
  CaregivingIcon: () => import('./CaregivingIcon'),
  Chat: () => import('./Chat'),
  ChatLiveIcon: () => import('./ChatLiveIcon'),
  ChatsIcon: () => import('./ChatsIcon'),
  CheckIcon: () => import('./CheckIcon'),
  CheckInIcon: () => import('./CheckInIcon'),
  CheckMarkIcon: () => import('./CheckMarkIcon'),
  CheckMarkIconV2: () => import('./CheckMarkIconV2'),
  CheckMarkInCircleIcon: () => import('./CheckMarkInCircleIcon'),
  CheckSuccessIcon: () => import('./CheckSuccessIcon'),
  ChevronIcon: () => import('./ChevronIcon'),
  ChevronV2Icon: () => import('./ChevronV2Icon'),
  ChildTherapyIcon: () => import('./ChildTherapyIcon'),
  CircleIcon: () => import('./CircleIcon'),
  CircleArrowIcon: () => import('./CircleArrowIcon'),
  CirclePlayIcon: () => import('./CirclePlayIcon'),
  CircleSlashIcon: () => import('./CircleSlashIcon'),
  ClinicalLeaveEvaluationIcon: () => import('./ClinicalLeaveEvaluationIcon'),
  ClockIcon: () => import('./ClockIcon'),
  CloseCircleBordered: () => import('./CloseCircleBordered'),
  CloseCircleIcon: () => import('./CloseCircleIcon'),
  CloseIcon: () => import('./CloseIcon'),
  CloseQuotationIcon: () => import('./CloseQuotationIcon'),
  ClientMessagingIcon: () => import('./ClientMessagingIcon'),
  ClientMessagingAiIcon: () => import('./ClientMessagingAiIcon'),
  ClientMessagingUnreadIcon: () => import('./ClientMessagingUnreadIcon'),
  ClinicalLeaveEvalIcon: () => import('./ClinicalLeaveEvalIcon'),
  ClipboardIcon: () => import('./ClipboardIcon'),
  ClipboardPlus: () => import('./ClipboardPlus'),
  ClipboardWithArrowIcon: () => import('./ClipboardWithArrowIcon'),
  OnsiteIcon: () => import('./OnsiteIcon'),
  ConnectNotificationsIcon: () => import('./ConnectNotificationsIcon'),
  ConnectInsightsSearchIcon: () => import('./ConnectInsightsSearchIcon'),
  CoachingIcon: () => import('./CoachingIcon'),
  ConsultationIcon: () => import('./ConsultationIcon'),
  CoachingForParentsIcon: () => import('./CoachingForParentsIcon'),
  ComposeIcon: () => import('./ComposeIcon'),
  ContactIcon: () => import('./ContactIcon'),
  ConversationIcon: () => import('./ConversationIcon'),
  CopyIcon: () => import('./CopyIcon'),
  CourseIcon: () => import('./CourseIcon'),
  CouplesTherapyIcon: () => import('./CouplesTherapyIcon'),
  CreditCardIcon: () => import('./CreditCardIcon'),
  DbtIcon: () => import('./DbtIcon'),
  DialecticalBehavioralTherapyIcon: () => import('./DialecticalBehavioralTherapyIcon'),
  DocumentSearchIcon: () => import('./DocumentSearchIcon'),
  DownloadFileIcon: () => import('./DownloadFileIcon'),
  DraftPageIcon: () => import('./DraftPageIcon'),
  EditIcon: () => import('./EditIcon'),
  EditIconBoxed: () => import('./EditIconBoxed'),
  EmailIcon: () => import('./EmailIcon'),
  EmotionsFeelingsIcon: () => import('./EmotionsFeelingsIcon'),
  EndCallIcon: () => import('./EndCallIcon'),
  EssentialsIcon: () => import('./EssentialsIcon'),
  EventsIcon: () => import('./EventsIcon'),
  EveningIcon: () => import('./EveningIcon'),
  ExpeditedBookingIcon: () => import('./ExpeditedBookingIcon'),
  ExternalCalendarIcon: () => import('./ExternalCalendarIcon'),
  ExternalLinkIcon: () => import('./ExternalLinkIcon'),
  EyeIcon: () => import('./EyeIcon'),
  FaceBiometricIcon: () => import('./FaceBiometricIcon'),
  FaceIdPromptIcon: () => import('./FaceIdPromptIcon'),
  FacebookIcon: () => import('./FacebookIcon'),
  FamilySessionIcon: () => import('./FamilySessionIcon'),
  FingerprintBiometricIcon: () => import('./FingerprintBiometricIcon'),
  FeedbackIcon: () => import('./FeedbackIcon'),
  FeedbackStarIcon: () => import('./FeedbackStarIcon'),
  FilterIcon: () => import('./FilterIcon'),
  FingerprintBiometricsPromptIcon: () => import('./FingerprintBiometricsPromptIcon'),
  FingerprintIcon: () => import('./FingerprintIcon'),
  FlagIcon: () => import('./FlagIcon'),
  FooterPhoneIcon: () => import('./FooterPhoneIcon'),
  GearIcon: () => import('./GearIcon'),
  Glass: () => import('./Glass'),
  GlobeIcon: () => import('./GlobeIcon'),
  GlobalSupportIcon: () => import('./GlobalSupportIcon'),
  ChartIcon: () => import('./ChartIcon'),
  GroupAddIcon: () => import('./GroupAddIcon'),
  GroupSessionIcon: () => import('./GroupSessionIcon'),
  HamburgerMenuIcon: () => import('./HamburgerMenuIcon'),
  HandHoldingHeartIcon: () => import('./HandHoldingHeartIcon'),
  HeartDottedBorderIcon: () => import('./HeartDottedBorderIcon'),
  HeartsIcon: () => import('./HeartsIcon'),
  HeartInHeadIcon: () => import('./HeartInHeadIcon'),
  HomeIcon: () => import('./HomeIcon'),
  HomeRoofHeart: () => import('./HomeRoofHeart'),
  InboxIcon: () => import('./InboxIcon'),
  IncidentsIcon: () => import('./IncidentsIcon'),
  InfoIcon: () => import('./InfoIcon'),
  InfoIconStroke: () => import('./InfoIconStroke'),
  InnovationIcon: () => import('./InnovationIcon'),
  InsertIntoTextIcon: () => import('./InsertIntoTextIcon'),
  LaptopIcon: () => import('./LaptopIcon'),
  LeafIcon: () => import('./LeafIcon'),
  LeaveSiteIcon: () => import('./LeaveSiteIcon'),
  LightbulbIcon: () => import('./LightbulbIcon'),
  LinkIcon: () => import('./LinkIcon'),
  LinkedIcon: () => import('./LinkedIcon'),
  LinkedInIcon: () => import('./LinkedInIcon'),
  ListItemsIconWithoutBorder: () => import('./ListItemsIconWithoutBorder'),
  LiveChatMessagingIcon: () => import('./LiveChatMessagingIcon'),
  LiveChatMessagingIconSvg: () => import('./LiveChatMessagingIconSvg'),
  LiveMessagingIcon: () => import('./LiveMessagingIcon'),
  LiveMessagingSessionListIcon: () => import('./LiveMessagingSessionListIcon'),
  LiveVideoModalityIcon: () => import('./LiveVideoModalityIcon'),
  LoadingIndicator: () => import('./LoadingIndicator'),
  LoadingSpinner: () => import('./LoadingSpinner'),
  LocationIcon: () => import('./LocationIcon'),
  LockIcon: () => import('./LockIcon'),
  LockIcon2: () => import('./LockIcon2'),
  LogoutIcon: () => import('./LogoutIcon'),
  LyraFaviconIcon: () => import('./LyraFaviconIcon'),
  LyraHealthAppIcon: () => import('./LyraHealthAppIcon'),
  LyraLogo: () => import('./LyraLogo'),
  MarketingIcon: () => import('./MarketingIcon'),
  MaximizeIcon: () => import('./MaximizeIcon'),
  MyCompanyIcon: () => import('./MyCompanyIcon'),
  MenuDotsIcon: () => import('./MenuDotsIcon'),
  MenuIcon: () => import('./MenuIcon'),
  MessagingClockIcon: () => import('./MessagingClockIcon'),
  MessageIcon: () => import('./MessageIcon'),
  MedicineIcon: () => import('./MedicineIcon'),
  MicrophoneIcon: () => import('./MicrophoneIcon'),
  MessagingIcon: () => import('./MessagingIcon'),
  MessagingModalityIcon: () => import('./MessagingModalityIcon'),
  MinimizeIcon: () => import('./MinimizeIcon'),
  MorningIcon: () => import('./MorningIcon'),
  NoPreferenceMatchIcon: () => import('./NoPreferenceMatchIcon'),
  MinusIcon: () => import('./MinusIcon'),
  MoneyIcon: () => import('./MoneyIcon'),
  NeuroPsychEvalIcon: () => import('./NeuroPsychEvalIcon'),
  NoteIcon: () => import('./NoteIcon'),
  NotesIcon: () => import('./NotesIcon'),
  NotificationIcon: () => import('./NotificationIcon'),
  NotificationPromptIcon: () => import('./NotificationPromptIcon'),
  NeurodiversityCOEToolkitIcon: () => import('./NeurodiversityCOEToolkitIcon'),
  NumberBadge: () => import('./NumberBadge'),
  OpenBookIcon: () => import('./OpenBookIcon'),
  OpenQuotationIcon: () => import('./OpenQuotationIcon'),
  PaginationIcon: () => import('./PaginationIcon'),
  PaperclipIcon: () => import('./PaperclipIcon'),
  PencilSparkleIcon: () => import('./PencilSparkleIcon'),
  PersonIcon: () => import('./PersonIcon'),
  PersonPlusIcon: () => import('./PersonPlusIcon'),
  PhoneIcon: () => import('./PhoneIcon'),
  Pills: () => import('./Pills'),
  PlusIcon: () => import('./PlusIcon'),
  PlusSignIcon: () => import('./PlusSignIcon'),
  PracticeSkillsIcon: () => import('./PracticeSkillsIcon'),
  ProfileCircleIcon: () => import('./ProfileCircleIcon'),
  ProgressIcon: () => import('./ProgressIcon'),
  QuestionMarkIcon: () => import('./QuestionMarkIcon'),
  RecordingIcon: () => import('./RecordingIcon'),
  RadarIcon: () => import('./RadarIcon'),
  RefreshIcon: () => import('./RefreshIcon'),
  RenewIcon: () => import('./RenewIcon'),
  ReportingIcon: () => import('./ReportingIcon'),
  ResourcesIcon: () => import('./ResourcesIcon'),
  RulerAndPencilIcon: () => import('./RulerAndPencilIcon'),
  RulerAndPencilIconFilled: () => import('./RulerAndPencilIconFilled'),
  RibbonHeartAnimation: () => import('./RibbonHeartAnimation'),
  RotatingProvidersLottie: () => import('./RotatingProvidersLottie'),
  ScheduleIcon: () => import('./ScheduleIcon'),
  ScoringIcon: () => import('./ScoringIcon'),
  SignOutIcon: () => import('./SignOutIcon'),
  SessionListCancelIcon: () => import('./SessionListCancelIcon'),
  SessionListLiveMessageIcon: () => import('./SessionListLiveMessageIcon'),
  SideNavMessageIcon: () => import('./SideNavMessageIcon'),
  SearchIcon: () => import('./SearchIcon'),
  SelfCareIcon: () => import('./SelfCareIcon'),
  SingleSessionCoachingIcon: () => import('./SingleSessionCoachingIcon'),
  SendArrowIcon: () => import('./SendArrowIcon'),
  SendIcon: () => import('./SendIcon'),
  SortIcon: () => import('./SortIcon'),
  SessionCompletedCheck: () => import('./SessionCompletedCheck'),
  SessionIcon: () => import('./SessionIcon'),
  SessionListPhoneIcon: () => import('./SessionListPhoneIcon'),
  SessionListPlayIcon: () => import('./SessionListPlayIcon'),
  SessionLocationIcon: () => import('./SessionLocationIcon'),
  ShareIcon: () => import('./ShareIcon'),
  ShieldTriageIcon: () => import('./ShieldTriageIcon'),
  ShootingStarIcon: () => import('./ShootingStarIcon'),
  SlidersIcon: () => import('./SlidersIcon'),
  SmartSuggestionIcon: () => import('./SmartSuggestionIcon'),
  SideBarIcon: () => import('./SideBarIcon'),
  SideNavCalendarIcon: () => import('./SideNavCalendarIcon'),
  SideNavCaseloadIcon: () => import('./SideNavCaseloadIcon'),
  SideNavClientIcon: () => import('./SideNavClientIcon'),
  SideNavDocumentIcon: () => import('./SideNavDocumentIcon'),
  SideNavDashboardIcon: () => import('./SideNavDashboardIcon'),
  SideNavHomeIcon: () => import('./SideNavHomeIcon'),
  SideNavHelpIcon: () => import('./SideNavHelpIcon'),
  SideNavSearchIcon: () => import('./SideNavSearchIcon'),
  SideNavSettingsIcon: () => import('./SideNavSettingsIcon'),
  SideNavToDoIcon: () => import('./SideNavToDoIcon'),
  SofaIcon: () => import('./SofaIcon'),
  SourcesStressIcon: () => import('./SourcesStressIcon'),
  SparkleGradient: () => import('./SparkleGradient'),
  SparklesAvatarIcon: () => import('./SparklesAvatarIcon'),
  SparklesIcon: () => import('./SparklesIcon'),
  SubtitleSettingIcon: () => import('./SubtitleSettingIcon'),
  SupportIcon: () => import('./SupportIcon'),
  SparkleSingleIcon: () => import('./SparkleSingleIcon'),
  SparkleSummariesIcon: () => import('./SparkleSummariesIcon'),
  SplashLogo: () => import('./SplashLogo'),
  SplashOrb: () => import('./SplashOrb'),
  StarRatingIcon: () => import('./StarRatingIcon'),
  TargetIcon: () => import('./TargetIcon'),
  TargetIconV2: () => import('./TargetIconV2'),
  TeenSessionIcon: () => import('./TeenSessionIcon'),
  TextBadge: () => import('./TextBadge'),
  ThoughtsBehaviorsIcon: () => import('./ThoughtsBehaviorsIcon'),
  ThumbIcon: () => import('./ThumbIcon'),
  ThumbnailPauseIcon: () => import('./ThumbnailPauseIcon'),
  ThumbnailPlayIcon: () => import('./ThumbnailPlayIcon'),
  ThinArrowIcon: () => import('./ThinArrowIcon'),
  TrendUpIcon: () => import('./TrendUpIcon'),
  TimeIcon: () => import('./TimeIcon'),
  TrashIcon: () => import('./TrashIcon'),
  TrophyIcon: () => import('./TrophyIcon'),
  TwitterIcon: () => import('./TwitterIcon'),
  UserChange: () => import('./UserChange'),
  UsersGroupAlt: () => import('./UsersGroupAlt'),
  VideoIcon: () => import('./VideoIcon'),
  VideoIconWithEllipse: () => import('./VideoIconWithEllipse'),
  VideoSessionIcon: () => import('./VideoSessionIcon'),
  VolumeUpIcon: () => import('./VolumeUpIcon'),
  WarningIcon: () => import('./WarningIcon'),
  WaveFormIcon: () => import('./WaveFormIcon'),
  WhiteCirclePlayIcon: () => import('./WhiteCirclePlayIcon'),
  XIcon: () => import('./XIcon'),
  XIconRound: () => import('./XIconRound'),
  ResultsScoreIcon: () => import('./ResultsScoreIcon'),
  ResultsLineIcon: () => import('./ResultsLineIcon'),
  CareReflectionIcon: () => import('./CareReflectionIcon'),
  LoadingRing: () => import('./LoadingRing'),
  FavoritedStar: () => import('./FavoritedStar'),
  SideNavLibraryIcon: () => import('./SideNavLibraryIcon'),
  CheckMarkOutOfCircleIcon: () => import('./CheckMarkOutOfCircleIcon'),
  MixLanguageWorldIcon: () => import('./MixLanguageWorldIcon'),
  InPersonStroke: () => import('./InPersonStroke'),
  UploadIcon: () => import('./UploadIcon'),
  UserCircleOutlineIcon: () => import('./UserCircleOutlineIcon'),
  SearchStarIcon: () => import('./SearchStarIcon'),
  HeadphoneHeartIcon: () => import('./HeadphoneHeartIcon'),
  SignatureIcon: () => import('./SignatureIcon'),
  InsightsOrbIcon: () => import('./InsightsOrbIcon'),
  AICoachIcon: () => import('./AICoachIcon'),
  AppIcon: () => import('./AppIcon'),
  BoldCheckJaggedIcon: () => import('./BoldCheckJaggedIcon'),
  ExclamationIcon: () => import('./ExclamationIcon'),
  FaceIdPromptIconSvg: () => import('./FaceIdPromptIconSvg'),
  FastForwardFifteenIcon: () => import('./FastForwardFifteenIcon'),
  FingerprintBiometricsPromptIconSvg: () => import('./FingerprintBiometricsPromptIconSvg'),
  FingerprintIconSvg: () => import('./FingerprintIconSvg'),
  LinkIconSvg: () => import('./LinkIconSvg'),
  ListIcon: () => import('./ListIcon'),
  NotificationIconSvg: () => import('./NotificationIconSvg'),
  PersonalInfoIcon: () => import('./PersonalInfoIcon'),
  PlayIcon: () => import('./PlayIcon'),
  QuickLinksIcon: () => import('./QuickLinksIcon'),
  RewindFifteenIcon: () => import('./RewindFifteenIcon'),
  ShieldIcon: () => import('./ShieldIcon'),
  SparklesAlternateIcon: () => import('./SparklesAlternateIcon'),
  SparklesAlternateIconSvg: () => import('./SparklesAlternateIconSvg'),
  SparklesAvatarIconImage: () => import('./SparklesAvatarIconImage'),
  StarIcon: () => import('./StarIcon'),
  TouchIdIcon: () => import('./TouchIdIcon'),
  TriageSummaryFeelingIcon: () => import('./TriageSummaryFeelingIcon'),
  TriageSummaryHealthPlanIcon: () => import('./TriageSummaryHealthPlanIcon'),
  TriageSummaryProviderIcon: () => import('./TriageSummaryProviderIcon'),
  TriageSummarySessionIcon: () => import('./TriageSummarySessionIcon'),
  CheckMarkBullet: () => import('./WorkLifeIcons'),
  WorkLifeIconCalendar: () => import('./WorkLifeIcons'),
  WorkLifeIconDependentCare: () => import('./WorkLifeIcons'),
  WorkLifeIconFamily: () => import('./WorkLifeIcons'),
  WorkLifeIconFinancial: () => import('./WorkLifeIcons'),
  WorkLifeIconHearts: () => import('./WorkLifeIcons'),
  WorkLifeIconIdentity: () => import('./WorkLifeIcons'),
  WorkLifeIconInclusion: () => import('./WorkLifeIcons'),
  WorkLifeIconLaptop: () => import('./WorkLifeIcons'),
  WorkLifeIconLaw: () => import('./WorkLifeIcons'),
  WorkLifeIconMindfulness: () => import('./WorkLifeIcons'),
  WorkLifeIconPencil: () => import('./WorkLifeIcons'),
  WorkLifeIconSquares: () => import('./WorkLifeIcons'),
}
